import React, { Component } from "react";
import Button from "../../components/Button/Button";
import "./Footer.scss";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <div id="contact_us" className="footer_container">
          <img
            src="../../images/background_image.jpg"
            alt="Motilal Oswal Asset Management Company Limited"
          ></img>
          <section className="text_box">
            <p className="subscrption_heading">
              To schedule a demo with one of our product consultants,
              please fill in your contact details
            </p>
            <div className="input-areas">
              <form>
                <div className="row mb-4">
                  <div className="col-md-6 col-sm-12 py-2">
                    <input
                      type="text"
                      name="name"
                      placeholder="Name"
                      className="footer-input-1 input_1"
                    ></input>
                  </div>
                  <div className="col-md-6 col-sm-12 py-2">
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      className="footer-input-1 input_1"
                    ></input>
                  </div>
                </div>
                <textarea
                  type="text"
                  name="message"
                  placeholder="Type your message here"
                  className="footer-input-2 input_2 py-3"
                ></textarea>
                <div className="btn_footer text-center my-5">
                  <Button
                    customClass="al_button_2"
                    buttonStyle="btn--outline"
                    buttonSize="btn--large"
                    text="Submit"
                  ></Button>
                </div>
              </form>
            </div>
            <div className="row contact_us mt-3">
              <div className="col-md-4 col-sm-6 border_right">
                <p>
                  Manish Sarawagi<br></br>
                  s.manish@pulselabs.co.in
                </p>
              </div>
              <div className="col-md-4 col-sm-6 border_right text-center">
                <p>Phone: 80734 61259</p>
              </div>
              <div className="col-md-4 col-sm-6">
                <p>
                  Shree Arcade, 2nd Floor,<br></br>
                  19th Main, Sector 4,<br></br>
                  HSR Layout, Bangalore
                </p>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

export default Footer;
